












import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import AuthFormContainer from '@/components/modules/Auth/AuthFormContainer.vue'
import UiButton from '@/components/ui/UiButton.vue'

interface Data {}

interface Methods {}

interface Computed {}

interface Props {}

export default Vue.extend({
  name: 'SignInProblemStep',
  components: {
    AuthFormContainer,
    UiButton
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
